<div>
	<h6 class="alert-danger p-3" *ngIf="successExtension === false">
		{{'error_msgs.invalid_file_extention' | translate}}
	</h6>
	<h6 class="alert-danger p-3" *ngIf="successSize === false">
		{{'error_msgs.invalid_file_size' | translate}}
	</h6>
	<h6 class="alert-danger p-3" *ngIf="successFilesCount === false">
		{{'error_msgs.select_exactly_2_files' | translate}}
	</h6>
</div>

<div class="mb-3 text-muted">
	<small>
		<i [innerHTML]="'g.expected_filename_format_hint' | translate"></i>
	</small>
</div>

<div class="row col-md-8 mb-3">
	<input #uploadFile hidden="true" type="file" multiple onclick="this.value = null" (change)="checkFile($event)"
		accept=".bin" />
	<div>
		<button mat-flat-button color="primary" (click)="uploadFile.click()">{{'g.select_file' | translate}}</button>
		<button mat-flat-button color="primary" class="ml-2"
			[disabled]="files.length !== minFilesCount || !successSize || !successExtension"
			(click)="upload()">{{'g.upload' | translate}}</button>
		</div>
		</div>

<div class="row col-md-8" *ngIf="files.length > 0">
	<div class="ml-3">
		<span>{{'g.files' | translate}}:</span>
		<ul class="mt-1">
			<li *ngFor="let file of files"><b>{{file.name}}</b></li>
		</ul>
	</div>
</div>
<sct-custom-table
	[columnsConfig]="columnConfig"
	[data]="tableData"
	[config]="tableConfig"
></sct-custom-table>

<app-modal
	#editNoteModal
	[hasCloseButton]="true"
	[hasConfirmButton]="true"
	[confirmBtnText]="'g.save' | translate"
	title="{{ 'devices.edit_note_for_version' | translate }}: {{editingVersion}}"
	size="lg"
>
	<textarea
		class="form-control"
		rows="5"
		[(ngModel)]="editingNote"
		[maxlength]="noteMaxLength"
		placeholder="{{ 'devices.note' | translate }}"
	></textarea>
</app-modal>
